module.exports = __webpack_public_path__ + "img/replace.bd913d9e.png";